import { ComponentConfigType } from '../../utils/data-parser';
import { ComponentType, type IConfig } from '../../types';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BODY_TRANSFORMER_TOOLTIP,
  JSON_LOGIC_SELECT_VALUE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FormReferenceTreeSelect,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'placeholder',
          label: 'Placeholder',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'modelIds',
          label: 'Model IDs',
          valueComponent: { type: 'ReferenceModelSelector' },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'modelInstanceFilters',
          label: 'Model Instance Filters',
          valueComponent: { type: 'DinamicDataFilters' },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: JSON_LOGIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'transformer',
          label: 'Transformer (JMESPath)',
          valueComponent: {
            type: 'CodeEditor',
            placeholder:
              '[].{label: data.translations[0].termName, value: id, modelId: modelId}',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BODY_TRANSFORMER_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'childKey',
          label: 'Child Key (JMESPath)',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., data.termId',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'parentKey',
          label: 'Parent Key (JMESPath)',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., data.parents[].parent',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'selectableExpression',
          label: 'Selectable When (JMESPath)',
          valueComponent: {
            type: 'Input',
            placeholder:
              "e.g., data.extendedAttributes[?attributeName=='SELECTABLE'].value | [0] == 'Y'",
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'leavesOnly',
          label: 'Only Leaf Nodes Selectable',
          valueComponent: { type: 'Switch', defaultValue: false },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'mode',
          label: 'Mode',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Single', value: 'default' },
              { label: 'Multiple', value: 'multiple' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'treeDefaultExpandAll',
          label: 'Expand All By Default',
          valueComponent: { type: 'Switch', defaultValue: false },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
  ],
};
